import {Component, Input, OnInit} from "@angular/core";
import {environment} from "../../../../environments/environment";

@Component({
    selector: 'app-status',
    templateUrl: './status.component.html',
})
export class StatusComponent implements OnInit{

    env = environment;
    status: number;
    @Input('project') project: any;
    @Input('is_list') list: boolean;

    constructor(){
    }

    ngOnInit(){
        if(this.list){
            this.status = this.project.status
        }else{
            this.project.subscribe(
                r => {
                    this.status = r.status;
                }
            )
        }
    }

    getStatusData(status: number, data: string){
        if(status != null){
            return this.env.status[status][data];
        }else{
            return this.env.status['default'][data];
        }
    }
}


// WEBPACK FOOTER //
// /Users/moe.dchater/personal/firebase-projects/hosting/src/app/projects/shared/status/status.component.ts